/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guidevideo_Remove_Poster1Inputs */

const vi_guidevideo_remove_poster1 = /** @type {(inputs: Guidevideo_Remove_Poster1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bỏ ảnh bìa`)
};

/**

* @param {Guidevideo_Remove_Poster1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const guidevideo_remove_poster1 = /** @type {((inputs?: Guidevideo_Remove_Poster1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guidevideo_Remove_Poster1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_guidevideo_remove_poster1(inputs)
});
export { guidevideo_remove_poster1 as "guideVideo_remove_poster" }